export const API_URL = process.env.BASE_URL

export const QN_URL = process.env.QN_URL

export const DD_REDIRECT = process.env.DD_REDIRECT

export const DD_BIND_REDIRECT = process.env.DD_BIND_REDIRECT


export const AUTH_ROLE = {
    zb: '总编',
    editor: '主编',
    writor: '编辑',
    secretary: '内勤',
    director: '总监',
    admin: '管理员',
    finance: '财务',
    sale: '销售'
}

export function qnUploadUrl() {
    var qnUploadUrl
    if (window.location.protocol === 'https:') {
      qnUploadUrl = 'https://up.qbox.me'
    } else {
      qnUploadUrl = 'http://upload.qiniu.com'
    }
    return qnUploadUrl
}




// WEBPACK FOOTER //
// ./src/utils/Global.js